import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {MiniGameState} from "./MiniGame";
import BatteryIndicator from "./BatteryIndicator";

interface Props extends MiniGameState
{

}

interface State
{
    opacity: number[];
}

import './WorldCup.scss';

const elements: string[] = ['grass', 'sky', 'balls'];

class WorldCup extends React.Component<Props, State>
{
    elements: HTMLElement[] = [];

    constructor(public props: Props)
    {
        super(props);
    }


    componentDidMount()
    {
        this.elements = [];
    }


    componentWillUnmount()
    {
        this.elements = null;
    }


    registerElement = (el: HTMLElement) =>
    {
        if (! el) return;

        this.elements.push(el);
    };


    getElements = () =>
    {
        const {energy} = this.props;
        const interval: number = 1 / elements.length;
        const current_value: number = energy / 100;

        if (! this.elements) return;

        //TODO  improve the spacing here

        const nodes = _.map(elements, (id: string, i: number) =>
        {
            const min_value: number = interval * i;
            const max_value: number = interval * (i + 1);

            const raw_opacity: number = (current_value - min_value) / (max_value - min_value);

            const opacity = _.clamp(raw_opacity || 0, 0, 1);

            return <div
                        styleName={id}
                        style={{ opacity }}
                        ref={this.registerElement}
                        key={i}/>
        });

        return nodes;
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {time_remaining, energy} = this.props;

        return <div>

            {this.getElements()}

        </div>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {}
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(WorldCup);



// WEBPACK FOOTER //
// ./src/ts/app/screens/mini-game/WorldCup.tsx